// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';

import homeBg from '../images/home-bg.png';

import Arrow from '../components/Arrow';
import Page from '../components/Page';
import Section from '../components/Section';
import SignUp from '../components/SignUp';
import Tool from '../components/Tool';

const Welcome = styled(Section)`
  background-image: linear-gradient(to bottom, ${props => props.theme.headerBg}, ${props => transparentize(1, props.theme.headerBg)} 20%), url(${homeBg});
  background-position: top, center;
  background-repeat: repeat, no-repeat;
  background-size: 100%, cover;
  @media (min-width: 375px) {
    padding: 3.5em 2em;
  }
`;

const toolsBg = '#D8D8D8';

const Tools = styled(Section)`
  background: ${toolsBg};
  padding: 0;
  > div {
    padding: 0 2em;
  }
  .arrow-inverted {
    position: relative;
    top: -23px;
  }
  .arrow-down {
    position: relative;
    top: 23px;
  }
`;

const Coming = styled.div`
  border-radius: 8px;
  border: 2px dashed #AAAAAA;
  color: #999999;
  font-size: 0.9em;
  font-weight: 600;
  margin-top: 1em;
  padding: 1em;
  text-align: center;
`;

class Home extends Component<{}> {

  render() {
    return (
      <Page>
        <Welcome primary>
          <h1>Welcome to Baart Tools</h1>
          <h2>Calculators and specifications to help you get your job done.</h2>
        </Welcome>

        <Tools>
          <Arrow color={toolsBg} inverted />
          <div>
            <Tool brand="vortex" />
            <Coming className="limit-width">More tools coming soon!</Coming>
          </div>
          <Arrow color={toolsBg} down />
        </Tools>

        <Section>
          <SignUp />
        </Section>
      </Page>
    );
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js